// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { moonbeam as _moonbeam } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the moonbeam chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1284
 * Chain Name: Moonbeam
 * Default Block Explorer: https://moonscan.io
 * Default RPC URL: https://moonbeam.public.blastapi.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { moonbeam } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: moonbeam,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const moonbeam = createCommon({
	..._moonbeam,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
